export default __webpack_public_path__ + "assets/images/Landing_page_logo1.9bfd2a93.svg";